export const ROUTE_PATH_ROOT = '';
export const ROUTE_PATH_FURNITURES = 'furnitures';
export const ROUTE_PATH_FENSEMBLES = 'fensembles';
export const ROUTE_PATH_FARRANGEMENTS = 'farrangements';
export const ROUTE_PATH_FLAYOUTS = 'flayouts';
export const ROUTE_PATH_DECORATIONS = 'decorations';
export const ROUTE_PATH_REAL_TIME_SHARING = 'rts';
export const ROUTE_PATH_REAL_TIME_SHARING_ID = 'rts/:sessionId';
export const ROUTE_PATH_SHARE = 'share';
export const ROUTE_PATH_RECORDER = 'recorder';
export const ROUTE_PATH_SETUP_TEMPLATES = 'templates';
export const ROUTE_PATH_INSPECTOR = 'inspector';
export const ROUTE_PATH_DEVTOOLS = 'devtools';

export const ROUTE_ABS_PATH_FURNITURES = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_FURNITURES}`;
export const ROUTE_ABS_PATH_FENSEMBLES = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_FENSEMBLES}`;
export const ROUTE_ABS_PATH_FARRANGEMENTS = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_FARRANGEMENTS}`;
export const ROUTE_ABS_PATH_FLAYOUTS = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_FLAYOUTS}`;
export const ROUTE_ABS_PATH_DECORATIONS = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_DECORATIONS}`;
export const ROUTE_ABS_PATH_REAL_TIME_SHARING = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_REAL_TIME_SHARING}`;
export const ROUTE_ABS_PATH_REAL_TIME_SHARING_ID = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_REAL_TIME_SHARING_ID}`;
export const ROUTE_ABS_PATH_SHARE = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_SHARE}`;
export const ROUTE_ABS_PATH_RECORDER = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_RECORDER}`;
export const ROUTE_ABS_PATH_TEMPLATES = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_SETUP_TEMPLATES}`;
export const ROUTE_ABS_PATH_INSPECTOR = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_INSPECTOR}`;
export const ROUTE_ABS_PATH_DEVTOOLS = `${ROUTE_PATH_ROOT}/${ROUTE_PATH_DEVTOOLS}`;
